import BaseAccordion from 'components/Accordions/BaseAccordion';
import WeatherCard from 'features/Weather/components/WeatherCard/WeatherCard';
import { skiReportSections } from '../../config/skiReports.config';
import { hasSkiReportValue } from '../../utils/skiReports.utils';

/**
 * Shows one resort's report as three cards inside a keyboard-accessible accordion.
 * BaseAccordion owns opening and closing; WeatherCard owns the shared card appearance.
 */
const SkiResortAccordion = ({ report }) => {
  const resortName = hasSkiReportValue(report.ski_area_name)
    ? report.ski_area_name
    : 'Unnamed ski resort';

  return (
    <BaseAccordion
      headingLevel="h3"
      header={<span className="fw-semibold text-break">{resortName}</span>}
    >
      <div className="row g-3 align-items-start">
        {skiReportSections.map(({ id, title, Icon, details, emptyMessage }) => {
          // The formatters return null for missing fields, so empty rows never reach the card.
          const availableDetails = details.filter((detail) => detail.getValue(report) !== null);

          return (
            <div
              key={id}
              className={id === 'operations' ? 'col-12 d-flex' : 'col-12 col-lg-6 d-flex'}
            >
              <WeatherCard
                weatherObj={report}
                title={title}
                headingLevel="h4"
                headerIcon={<Icon size={24} aria-hidden="true" />}
                details={availableDetails}
                emptyMessage={emptyMessage}
              />
            </div>
          );
        })}
      </div>
    </BaseAccordion>
  );
};

export default SkiResortAccordion;
